import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Grid,
  Divider,
  Rating,
  Chip,
} from '@mui/material';
import dayjs from 'dayjs';
import { Task } from '../../../types';

interface CompletedFormViewProps {
  task: Task;
}

export const CompletedFormView: React.FC<CompletedFormViewProps> = ({ task }) => {
  const { metadata } = task;
  if (!metadata) return null;

  const renderValue = (value: any) => {
    if (value === undefined || value === null || value === '') {
      return <Typography color="text.secondary">Not provided</Typography>;
    }

    if (typeof value === 'boolean') {
      return <Chip 
        label={value ? 'Yes' : 'No'} 
        color={value ? 'success' : 'default'} 
        size="small" 
      />;
    }

    if (dayjs.isDayjs(value)) {
      return value.format('MMMM D, YYYY');
    }

    if (typeof value === 'number' && task.title.includes('Assessment')) {
      return <Rating value={value} readOnly />;
    }

    return <Typography>{value}</Typography>;
  };

  const formatKey = (key: string) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {task.title}
        </Typography>
        <Typography color="text.secondary" variant="body2">
          Completed on {new Date(task.metadata.completedAt || task.dueDate).toLocaleDateString()}
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Grid container spacing={3}>
        {Object.entries(metadata).map(([key, value]) => {
          if (key === 'completedAt') return null;
          
          return (
            <Grid item xs={12} key={key}>
              <Box>
                <Typography 
                  variant="subtitle2" 
                  color="text.secondary"
                  gutterBottom
                  sx={{ mb: 1 }}
                >
                  {formatKey(key)}
                </Typography>
                {renderValue(value)}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
};